import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { PolicyClient } from '@models/swagger';
import { PoliciesParams } from './service';

export enum PoliciesActions {
  Failure = '[Application Utilities Policies] Failure',
  Request = '[Application Utilities Policies] Request',
  Success = '[Application Utilities Policies] Success',
}

export const PoliciesFailure = createAction(PoliciesActions.Failure, props<{ error: HttpErrorResponse }>());

export const PoliciesRequest = createAction(PoliciesActions.Request, props<{ parameters: PoliciesParams }>());

export const PoliciesSuccess = createAction(PoliciesActions.Success, props<{ data: PolicyClient[] }>());
